import React from "react";
import { connect } from "react-redux";
import PresenterJoining from "./PresenterJoining";
import PresenterPresenting from "./presenting";
import Over from "./Over";

const Presenter = ({ status }) => {
  if (status === "Joining") {
    return <PresenterJoining />;
  } else if (status === "Presenting") {
    return <PresenterPresenting />;
  } else if (status === "Over") {
    return <Over />;
  }
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Presenter);
